import type { AccountUserProfileHoroscope } from '../services/accountUserProfileService';
import { getHoroscopeMeta } from '../utils/horoscopeCatalog';
import { HOROSCOPE_LUCIDE_ICONS } from '../utils/horoscopeLucideIcons';

type HoroscopeIconProps = {
  horoscope: AccountUserProfileHoroscope;
  size?: number;
  selected?: boolean;
  className?: string;
};

export function HoroscopeIcon({
  horoscope,
  size = 44,
  selected = false,
  className = '',
}: HoroscopeIconProps) {
  const IconComponent = HOROSCOPE_LUCIDE_ICONS[horoscope];
  const meta = getHoroscopeMeta(horoscope);
  const iconSize = Math.round(size * 0.5);

  return (
    <span
      className={[
        'inline-flex items-center justify-center rounded-full border text-primary-strong',
        selected ? 'border-primary bg-[#EAF2FF]' : 'border-border bg-canvas',
        className,
      ].join(' ')}
      style={{ width: size, height: size }}
      aria-label={meta?.label}
    >
      <IconComponent size={iconSize} strokeWidth={2} className="text-primary-strong" />
    </span>
  );
}
